import type { ReactNode } from 'react';

interface PanelHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export function PanelHeader({ title, subtitle, actions }: PanelHeaderProps) {
  return (
    <div className="panel-header">
      <div>
        <h2 className="panel-header__title">{title}</h2>
        {subtitle && <div className="panel-header__subtitle">{subtitle}</div>}
      </div>
      {actions}
    </div>
  );
}
